import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import ButtonVariant from './ButtonVariant';

import { IFLButton } from './Button.types';
import { containerStyle, textStyle, iconStyle } from './Button.tailwind';

const FLButton: FC<IFLButton> = props => {
  const { classes } = props;

  const customClasses = {
    text: twMerge(textStyle, classes?.text),
    icon: twMerge(iconStyle, classes?.icon),
    container: twMerge(containerStyle(!!props.icon), classes?.container),
  };

  return <ButtonVariant {...props} classes={customClasses} />;
};

export default FLButton;
